type PageLoaderProps = {
  label?: string;
};

export function PageLoader({
  label = "Loading...",
}: PageLoaderProps) {
  return (
    <div className="flex min-h-[240px] w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-emerald-200 border-t-emerald-600" />
        <p className="text-sm font-medium text-slate-600">{label}</p>
      </div>
    </div>
  );
}

export default PageLoader;